import { AssetConfig } from "@/types";
export const assets: AssetConfig = {
  people: { ext: "jpg", prefix: "image-", min: 1, max: 140, pad: 3 },
};
